export const TAG_RESOURCES = `
  mutation TagResources($token: String!, $mapContractId: String!) {
    tagResources(token: $token, mapContractId: $mapContractId) {
      error {
        code
        message
        statusCode
      }
      data {
        tagged
        failed
        errors
      }
    }
  }
`
